import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const unLinkQNsToSurveyAction = createAsyncThunk(
    'unlink-qns-survey',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/unlink-qns-survey`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const unLinkQNsToSurveySlice = createSlice({
    name: 'unlink-qns-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(unLinkQNsToSurveyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(unLinkQNsToSurveyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(unLinkQNsToSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const unLinkQNsToSurveyReducer = unLinkQNsToSurveySlice.reducer    